(function($){
    $(document).on('click','.custom-qty-minus',function(e){

        e.preventDefault();
        var quantity = Number($('.custom-qty-value').val());

        if(quantity > 1){
            quantity = Number(quantity) - 1;
            $('.custom-qty-value').val(quantity);
            $('.quantity input').val(quantity);
        }

    });

    $(document).on('click','.custom-qty-plus',function(e){

        e.preventDefault();
        var quantity = Number($('.custom-qty-value').val());
        quantity = Number(quantity) + 1;

        $('.custom-qty-value').val(quantity);
        $('.quantity input').val(quantity);

    });

    $(document).on('change','.custom-qty-value',function(e){

        e.preventDefault();
        var quantity = Number($('.custom-qty-value').val());

        if(quantity < 1){
            quantity = 1;
            $('.custom-qty-value').val(1);
        }

        $('.quantity input').val(quantity);

    });

})(jQuery);

